<template>
  <div class="pk-result" v-if="result">
    <em class="close cursor" @click="close"></em>
    <img :src="imgUrlData[result].light_img_url" class="light" alt="">
    <div class="pk-result-box">
      <div class="title">
        <div class="pk-result-anim"></div>
        <span class="hint" v-if="closeTime">{{closeTime}}s自动关闭</span>
        <img :src="imgUrlData[result].tit_img_url" alt="">
      </div>
      <section>
        <dl class="left">
          <dt><img :src="imgUrlData[result].self_icon" alt=""></dt>
          <dd>
            <span><i>{{pkData.team_score}}</i><em>积分</em></span>
            <span><i>我方</i><em>{{(!smallClassId && internal_users)?"内部班":smallClassName}}</em></span>
          </dd>
        </dl>
        <dl class="right">
          <dt><img :src="imgUrlData[result].other_icon" alt=""></dt>
          <dd>
            <span><i>{{pkData.adversary_score}}</i><em>积分</em></span>
            <span><em>{{pkData.adversary_small_name}}</em><i>对方</i></span>
          </dd>
        </dl>
      </section>
      <div class="bottom">
        <h2>- 本班贡献之星 -</h2>
        <div>
           <dl v-for="(item,index) in pkData.leading" :key="index">
          <dt>
            <img class="crown" :src="`/static/img/video/pk/${item.rank}.png`" alt="">
            <img class="photo" :src="item.avatar" alt="">
          </dt>
          <dd>
            <b>{{item.name}}</b>
            <i>{{index | level}}</i>
          </dd>
        </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web-limi";
import { mapState } from "vuex";
export default {
  name: "pk-result",
  data() {
    return {
      imgUrlData: {
        win: {
          tit_img_url: "/static/img/video/pk/win_title.png",
          light_img_url: "/static/img/video/pk/win_light.png",
          self_icon: "/static/img/video/pk/win.png",
          other_icon: "/static/img/video/pk/lose.png",
          lottie_url: "/static/lottie/pk/win/index.json"
        },
        lose: {
          tit_img_url: "/static/img/video/pk/lose_title.png",
          light_img_url: "/static/img/video/pk/lose_light.png",
          self_icon: "/static/img/video/pk/lose_self.png",
          other_icon: "/static/img/video/pk/win.png",
          lottie_url: "/static/lottie/pk/lose/index.json"
        },
        ping: {
          tit_img_url: "/static/img/video/pk/ping_title.png",
          light_img_url: "/static/img/video/pk/ping_light.png",
          self_icon: "/static/img/video/pk/ping.png",
          other_icon: "/static/img/video/pk/ping.png",
          lottie_url: "/static/lottie/pk/ping/index.json"
        }
      },
      result: "",
      anim: null
    };
  },
  computed: {
    ...mapState(["smallClassName","smallClassId","internal_users"])
  },
  props: ["pkData", "closeTime"],
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      const team_score = this.pkData.team_score;
      const adversary_score = this.pkData.adversary_score;
      if (team_score === adversary_score) {
        this.result = "ping";
      } else if (team_score > adversary_score) {
        this.result = "win";
      } else {
        this.result = "lose";
      }
      this.$nextTick(this.animInit);
      this.$emit('closeInterval',8);
    },
    animInit() {
      const lottieUrl = this.imgUrlData[this.result].lottie_url;
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".pk-result-anim"),
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: true,
        path: lottieUrl
      });
    },
    close() {
      this.anim && this.anim.destroy();
      this.$emit("close");
    }
  },
  filters: {
    level(val) {
      if (val === 0) return "第一名";
      else if (val === 1) return "第二名";
      else if (val === 2) return "第三名";
    }
  },
  beforeDestroy() {
    this.anim && this.anim.destroy();
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.pk-result {
  position: relative;
  width: 660px;
  height: 428px;
}
.light {
  position: absolute;
  z-index: 1;
  width: 450px;
  top: -110px;
  left: 100px;
  animation: rotateMotivate 18s infinite linear;
}
.pk-result-box {
  position: absolute;
  z-index: 2;
  width: 660px;
  height: 428px;
  background: #ffffff;
  border-radius: 15px;
  top: 0;
}
.close {
  position: absolute;
  right: -40px;
  top: -40px;
  width: 43px;
  height: 43px;
  background: url("../../../../assets/img/common/close.png") no-repeat;
  background-size: cover;
}
.title {
  height: 180px;
  margin-top: -90px;
  line-height: 180px;
   span {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #B6B6B6;
    line-height: 1.2;
  }
  img {
    width: 450px;
  }
  .pk-result-anim {
    position: absolute;
    z-index: 2;
    width: 450px;
    left: 105px;
  }
}
section {
  width: 575px;
  height: 160px;
  margin: 10px auto;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  justify-content: space-between;
  dl {
    width: 306px;
    height: 135px;
    border-radius: 12px;
    span {
      display: block;
      text-align: left;
      line-height: 1.6;
      &:first-child {
        color: #ffffff;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        i {
          font-size: 30px;
          margin-right: 3px;
        }
      }
      &:last-child {
        padding-top: 9px;
        i {
          font-size: 14px;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.2);
          padding: 1px 8px;
          border-radius: 13px;
        }
      }
    }
  }
  dt {
    width: 80px;
    img {
      width: 100%;
    }
  }
  dd {
    width: 165px;
    margin-top: 13px;
    float: right;
    span:last-child {
      display: flex;
      em {
        display: inline-block;
        width: 80px;
        height: 25px;
        overflow: hidden;
      }
    }
  }
  .left {
    background: url("../../../../assets/img/video/pk/red_bg_1.png") no-repeat;
    background-size: cover;
    margin-left: -16px;
    dd {
      margin-right: 14px;
    }
    dt {
      float: left;
      margin: 17px 0 0 20px;
    }
    span:last-child i {
      margin-right: 10px;
    }
    span:last-child em {
      color: #740c00;
    }
  }
  .right {
    background: url("../../../../assets/img/video/pk/blue_bg_1.png") no-repeat;
    background-size: cover;
    dd {
      float: left;
      margin-left: 14px;
    }
    dt {
      float: right;
      margin: 17px 20px 0 0;
    }
    span {
      display: block;
      text-align: right;
      justify-content: flex-end;
    }
    span:last-child i {
      margin-left: 10px;
    }
    span:last-child em {
      color: #002680;
    }
  }
}
.bottom {
  margin-top: 24px;
  h2 {
    color: #e99b00;
    font-size: 20px;
  }
  div {
    display: flex;
    justify-content: center;
    margin: 20px 50px;
  }
  dl {
    display: flex;
    justify-content: center;
    float:left;
    width:186px;
  }
  dd {
    text-align: left;
  }
  dt {
    position: relative;
    margin-right: 15px;
  }
  b {
    display: block;
    margin-top: 5px;
    font-size: 18px;
    color: #333333;
    max-width: 80px;
    word-break: break-all;
    height: 25px;
    overflow: hidden;
  }
  i {
    color: #999999;
    font-size: 14px;
  }
  .crown {
    width: 30px;
    position: absolute;
    right: -5px;
    top: -13px;
  }
  .photo {
    width: 55px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/pk/pkResult.vue